import React from "react";
import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

const ContactOne = () => {

  const [formData, setFormData] = useState({
    fname: "",
    email: "",
    phone: "",
    service: "option0",
  });
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!formData.fname.trim()) {
      newErrors.fname = "Name is required.";
    }
    if (!formData.email.trim() || !emailRegex.test(formData.email)) {
      newErrors.email = "Valid email is required.";
    }
    if (!formData.phone.trim() || !phoneRegex.test(formData.phone)) {
      newErrors.phone = "Valid 10-digit phone number is required.";
    }
    if (!formData.service || formData.service === "option0") {
      newErrors.service = "Please select a service.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" }); // Clear error for the field being updated
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (validateForm()) {
      try {
        const response = await axios.post("/api/contact", formData, {
          headers: { "Content-Type": "application/json" },
        });
  
        if (response.status === 200) {
          setSuccessMessage("Your message was sent successfully!");
          toast?.success("Your message was sent successfully!")

          // Reset form data
          setFormData({
            fname: "",
            email: "",
            phone: "",
            service: "option0",
          });
        } else {
          toast?.error(response?.data?.error ?? "Failed to send the message... Please try again later.")
          setSuccessMessage(response.data.error || "Failed to send the message.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast?.error("An error occurred. Please try again later.")
        setSuccessMessage("An error occurred. Please try again later.");
      }
    } else {
      setSuccessMessage("");
    }
  };

  return (
    <section className="contact_form_area">
      <div className="contact_form_width">
        <h1 className="contact_map_title text-center">
          We&apos;re not putting on airs - our work is guaranteed to satisfy.
        </h1>
        <div id="map">
          <iframe
            title="template google map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3661.160293862516!2d72.97313737601613!3d23.418576101433004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395dc5e0c676f08f%3A0x4d470c534cd8a4b2!2sGREECO%20PLAST%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1732518605521!5m2!1sen!2sin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div className="contact_form_width contact-right">
        <div className="hero-title-with-shape">
          <h4 className="heading_with_border">Get a free quote</h4>
          <h1>To request a service call, please fill out the form below</h1>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="d-flex gap-3">
            <div className="d-flex flex-column mb-3 w-100">
              <input
                className="half_width input_m_right w-100"
                type="text"
                name="fname"
                placeholder="Your name"
                value={formData.fname}
                onChange={handleInputChange}
              />
              {errors.fname && <span className="error-message text-danger">{errors.fname}</span>}
            </div>
            <div className="d-flex flex-column mb-3 w-100">
              <input
                className="half_width w-100"
                type="EMAIL"
                name="email"
                placeholder="Email address"
                value={formData.email}
                onChange={handleInputChange}
              />
              {errors.email && <span className="error-message text-danger">{errors.email}</span>}
            </div>
          </div>
          <div className="d-flex flex-column mb-3">
            <input
              type="tel"
              name="phone"
              placeholder="Phone number"
              value={formData.phone}
              onChange={handleInputChange}
            />
            {errors.phone && <span className="error-message text-danger">{errors.phone}</span>}
          </div>
          <div className="d-flex flex-column mb-3">
            <span className="select_icon">
              <select
                name="service"
                id="select"
                value={formData.service}
                onChange={handleInputChange}
                className={errors.service && "error"}
              >
                <option value="option0">Select a service</option>
                <option value="option1">Modular Kitchen</option>
                <option value="option2">Office Furniture</option>
                <option value="option3">Home Furniture</option>
                <option value="option4">Partition</option>
                <option value="option5">Door</option>
                <option value="option6">Louvers</option>
              </select>
            </span>
            {errors.service && (
              <span className="error-message text-danger">{errors.service}</span>
            )}
          </div>
          <button className="btn-green" value="SUBMIT NOW">
            SUBMIT NOW
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactOne;
